export default __webpack_public_path__ + "static/media/male.6c22cdc3.svg";